<template>
    <v-card class="ma-3 pa-5">
        <h3>Perco installation</h3>
        <v-row class="mx-2 mt-3">
            <v-autocomplete
                v-model="selectedStation"
                :items="probes"
                item-text="name"
                item-value="id"
                class="mr-3"
                label="Station"
                :disabled="percoInterval != null"
            >
            </v-autocomplete>
            <v-select
                :items="frequencyOptions"
                class="mr-3"
                label="Frequency"
                small
                :disabled="percoInterval != null"
                v-model="frequency"
            />
            <v-btn v-if="!percoInterval" class="mt-4" @click="handleFetchClick" color="primary">Fetch</v-btn>
            <v-btn v-else class="mt-4" @click="handleCancelClick" color="danger">Cancel</v-btn>
        </v-row>
        <v-row v-if="items.length > 0">
            <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-1"
            >
                <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
                    <span :key="header.value">
                        <span v-if="header.value !== 'ID'">{{ item[header.value] ? item[header.value] : '-' }}</span>
                        <span v-else>
                            {{ items.length - items.indexOf(item) }}
                        </span>
                    </span>
                </template>
            </v-data-table>
        </v-row>
    </v-card>
</template>
<script>

import PercoService from '../../service/PercoService';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'PercoInstallationPanel',
    data() {
        return {
            selectedStation: null,
            percoInterval: null,
            items: [],
            frequencyOptions: [1000, 2000, 3000, 4000, 5000, 10000],
            frequency: 5000,
            headers: [
                {text: 'ID', value: 'ID'},
                {text: 'Date', value: 'thedate'},
                {text: 'Mset Date', value: 'msetdate'},
                {text: 'ER', value: 'er'},
                {text: 'J', value: 'j'},
                {text: 'Temperature', value: 't'},
                {text: 'J MV', value: 'j_mv'},
                {text: 'ER MV', value: 'er_mv'},
                {text: 'I2C Temperature', value: 'i2c_temp'},
                {text: 'I2C RH', value: 'i2c_rh'},
                {text: 'I2C AX', value: 'i2c_ax'},
                {text: 'I2C AY', value: 'i2c_ay'},
                {text: 'I2C AZ', value: 'i2c_az'},
                {text: 'V', value: 'v'},
                {text: 'Alias', value: 'alias'},
                {text: 'Import Date', value: 'importdate'},
                {text: 'Sequence', value: 'sequence'},
            ],
        };
    },
    computed: {
        ...mapState('probe', ['probes']),
    },
    mounted() {
        if (!this.probes.length) {
            this.fetchAppSettings()
        }
    },
    beforeDestroy() {
        this.clear();
    },
    methods: {
        ...mapActions('app', ['fetchAppSettings']),
        async handleFetchClick() {
            this.items = [];
            await this.fetchPercoData();
            this.percoInterval = setInterval(this.fetchPercoData, this.frequency || 5000);
        },
        async fetchPercoData() {
            try {
                const response = await PercoService.getByStationId(this.selectedStation);

                if (response && response.data && response.data.measurements) {
                    response.data.measurements.forEach(m => {
                        this.items.unshift(m);
                    });

                    if (response.data.measurements.length === 0) {
                        this.items.unshift({"thedate": "-"})
                    }
                }
            } catch (e) {
                console.error(e);
                this.items.unshift({"thedate": "-"})
            }
        },
        handleCancelClick() {
            this.clear();
        },
        clear() {
            if (this.percoInterval) {
                clearInterval(this.percoInterval);
                this.percoInterval = null;
            }
        },
    },
};
</script>

<style scoped>

</style>